import React, { useEffect, useState } from "react";
import {
    slotslist,
    stuacademicyearlist,
    stuclasslist,
    studivisionlist,
    stusubjectlist,
} from "../../../services/master";
import Select from "react-select";
import {
    academylist,
    listtimetabledet,
    savetimetabledet,
} from "../../../services/admin";
import { toast } from "react-toastify";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import Swal from "sweetalert2";
import { studentviewdetail } from "../../../services/student";
import { teacherfilter } from "../../../services/teacher";

export default function AllTimetableSlot() {
    const [periods, setPeriod] = useState([]);
    const days = [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Action",
    ];


    const studays = [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
    ];

    const [ttype, setTType] = useState("");
    const [ayear, setAYear] = useState("");
    const [ylist, setYList] = useState([]);
    const [sclass, setSClass] = useState("");
    const [clist, setCList] = useState([]);
    const [studiv, setStuDiv] = useState("");
    const [divlist, setDivList] = useState([]);
    const [sublist, setSubList] = useState([]);
    const [tlist, setTList] = useState([]);
    const [errorMsg, setErrorMsg] = useState("");

    const [terrorMsg, setTErrorMsg] = useState("");

    const [alist, setAList] = useState([]);
    const [acaid, setAcaID] = useState("");
    const [cname, setCName] = useState("");
    useEffect(() => {
        if (localStorage.getItem("Role") === "4") {
            studentviewdetail(localStorage.getItem("UID")).then((res) => {
                if (res.status === true && res.data.details !== null) {
                    setCName(res.data.details.class_name + " Std - " + res.data.details.section_name);
                    const temp1 = new FormData();
                    if (localStorage.getItem("Role") === "1" && acaid !== "") {
                        temp1.append("academy_id", acaid.value);
                    }
                    temp1.append("class", res.data.details.class_id);
                    temp1.append("section", res.data.details.section_id);
                    temp1.append("year", res.data.details.academicyear);

                    listtimetabledet(temp1).then((res) => {
                        if (res.status === true) {
                            let timetableData = res.data;
                            setTShow(true);
                            slotslist(temp1).then((res1) => {
                                if (res1.status === true) {
                                    setPeriod(res1.data);
                                    const allPeriods = res1.data;
                                    const mergedPeriods = allPeriods.map((period) => {
                                        const daysData = {};
                                        studays.forEach((day) => {
                                            const entry = timetableData.find(
                                                (item) => item.period === period.id && item.day === day
                                            );
                                            daysData[day] = entry || null;
                                        });
                                        return {
                                            ...period,
                                            days: daysData // attach timetable data if available
                                        };
                                    });
                                    setPeriod([...mergedPeriods]);
                                }
                            })

                        }
                    });
                    // const temp = new FormData();
                    // temp.append("class", res.data.details.class_id);
                    // temp.append("year", res.data.details.academicyear);
                    // temp.append("section", res.data.details.section_id);
                    // temp.append("type", 'Students');
                    //   listtimetable(temp).then((res) => {
                    //     if (res.status === true) {
                    //       if (res.data.length > 0) {
                    //         let arr = [];
                    //         for (let i = 0; i < res.data.length; i++) {
                    //           arr.push({
                    //             id: res.data[i].id,
                    //             time: res.data[i].timeperiod,
                    //             name: res.data[i].t_lecture,
                    //             academy: res.data[i].academy_name,
                    //             schedule: [
                    //               res.data[i].monday,
                    //               res.data[i].tuesday,
                    //               res.data[i].wednesday,
                    //               res.data[i].thursday,
                    //               res.data[i].friday,
                    //               res.data[i].saturday,
                    //             ],
                    //           });
                    //         }
                    //         setPeriod(arr);
                    //         setLoading(false);
                    //       } else {
                    //         setTShow(true);
                    //         setLoading(false);
                    //       }
                    //     } else {
                    //       setLoading(false);
                    //       toast.error(res.message);
                    //     }
                    //   });
                }
            })
        } else {
            stuclasslist().then((res) => {
                if (res.status === true) {
                    let arr = [];
                    if (res.data.length > 0) {
                        for (let i = 0; i < res.data.length; i++) {
                            arr.push({
                                value: res.data[i].id,
                                label: res.data[i].class_name,
                            });
                        }
                        setCList(arr);
                    }
                }
            });

            studivisionlist().then((res) => {
                if (res.status === true) {
                    let arr = [];
                    if (res.data.length > 0) {
                        for (let i = 0; i < res.data.length; i++) {
                            arr.push({
                                value: res.data[i].id,
                                label: res.data[i].name,
                            });
                        }
                        setDivList(arr);
                    }
                }
            });

            academylist().then((res) => {
                if (res.status === true) {
                    let arr = [];
                    if (res.data.details.length > 0) {
                        for (let i = 0; i < res.data.details.length; i++) {
                            arr.push({
                                value: res.data.details[i].id,
                                label:
                                    res.data.details[i].name + " - " + res.data.details[i].code,
                            });
                        }
                        setAList(arr);
                    }
                }
            });
            if (localStorage.getItem("AAcademy") != null) {
                academylist().then((res) => {
                    if (res.status === true) {
                        let arr = [];
                        if (res.data.details.length > 0) {
                            for (let i = 0; i < res.data.details.length; i++) {
                                if (res.data.details[i].id == localStorage.getItem("AAcademy")) {
                                    arr.push({
                                        value: res.data.details[i].id,
                                        label:
                                            res.data.details[i].name + " - " + res.data.details[i].code,
                                    });
                                }
                                if (arr.length > 0) {
                                    setAcaID(arr[0]);
                                    listyear(arr[0]);
                                    setAYear(localStorage.getItem("AYear"));
                                }
                            }

                        }
                    }
                });
            } else {
                listyear("");
            }
        }
    }, []);

    function handleClass(e) {
        if (e !== null) {
            setSClass(e);
        } else {
            setSClass("");
        }
    }

    function handleDiv(e) {
        if (e !== null) {
            setStuDiv(e);
        } else {
            setStuDiv("");
        }
    }

    function searchtime() {
        if (ayear !== "") {
            if (sclass !== "") {
                if (studiv !== "") {
                    listtime();
                    setTShow(true);

                } else {
                    toast.error("Please Select Section");
                }
            } else {
                toast.error("Please Select Class");
            }
        } else {
            toast.error("Please Select Academic Year");
        }
    }


    function handledelete(did) {
        Swal.fire({
            text: "Are you sure want to delete?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#ac0404",
            cancelButtonColor: "#6259ca",
            confirmButtonText: "Delete",
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                const temp = new FormData();
                temp.append("id", did);
                // timetabledelete(temp).then((response) => {
                //   if (response.status === true) {
                //     toast.success(response.message);
                //     searchtime();
                //   }
                // });
            }
        });
    }

    function handleAcademy(e) {
        if (e !== null) {
            setAcaID(e);
            listyear(e);
        } else {
            setAcaID("");
            listyear("");
        }
    }

    function listyear(aid) {
        setYList([]);
        setAYear("");
        const temp = new FormData();
        if (localStorage.getItem("Role") === "1" && aid !== "") {
            temp.append("academy_id", aid.value);
        }
        stuacademicyearlist(temp).then((res) => {
            if (res.status === true) {
                setYList(res.data);
            }
        });

        slotslist(temp).then((res) => {
            if (res.status === true) {
                setPeriod(res.data);
            }
        })

        stusubjectlist(temp).then((res) => {
            if (res.status === true) {
                setSubList(res.data);
            }
        });
        const temp1 = new FormData();
        if (localStorage.getItem("Role") === "1" && aid !== "") {
            temp1.append("academy", aid.value);
        }
        teacherfilter(temp1).then((res) => {
            if (res.status === true) {
                let arr = [];
                if (res.data.details.length > 0) {
                    for (let i = 0; i < res.data.details.length; i++) {
                        const teacher = res.data.details[i];
                        if (teacher.subject_name) {
                            arr.push({
                                value: teacher.teacher_id,
                                label: `${teacher.username} - ${teacher.teacher_name} (${teacher.subject_name})`,
                            });
                        } else {
                            // Optionally, you could skip or show without subject name
                            arr.push({
                                value: teacher.teacher_id,
                                label: `${teacher.username} - ${teacher.teacher_name}`,
                            });
                        }
                    }
                    setTList(arr);
                }
            }
        })
    }


    const [loading, setLoading] = useState(false);
    const [tshow, setTShow] = useState(false);

    const headers = ["Lecture/Day", ...days];
    const studaysHeaders = ["Lecture/Day", ...studays];
    const convertToCSV = () => {
        const rows = [];
        // Push headers depending on role
        if (localStorage.getItem("Role") !== "4") {
            rows.push(headers);
        } else {
            rows.push(studaysHeaders);
        }

        periods.forEach((period) => {
            if (localStorage.getItem("Role") !== "4") {
                row.push(period.academy);
            }
            // const row = [period.name]; 
            // row.push(period.time); 
            const nameAndTime = `${period.name} (${period.time})`;
            const row = [nameAndTime];
            row.push(...period.schedule); // Add schedule for each day
            rows.push(row);
        });

        // Convert rows to CSV string
        return rows.map(row => row.join(",")).join("\n");
    };

    // Function to trigger CSV download
    const downloadCSV = () => {
        const csvData = convertToCSV();
        const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });

        // Create a download link and trigger the download
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", cname + ".csv");
        link.click();
        URL.revokeObjectURL(url);
    };


    const [showModal, setShowModal] = useState(false);
    const [selectedCell, setSelectedCell] = useState({});
    const [subject, setSubject] = useState("");
    const [teacher, setTeacher] = useState("");
    function handleStu(e) {
        if (e !== null) {
            setTeacher(e);
        } else {
            setTeacher("");
        }
    }
    const handleCellClick = (day, period) => {
        if(localStorage.getItem("Role") !== "4"){
             setSubject('');
            setTeacher('');
            if (period.is_break == 'No') {
                setSelectedCell({ day, period });
                setShowModal(true);
            }
        }
       
    };

    const handleSave = () => {
        if (subject !== '') {
            if (teacher !== '') {
                const temp = new FormData();
                temp.append("class_id", sclass.value);
                temp.append("section_id", studiv.value);
                temp.append("academic_year_id", ayear);
                temp.append("subject_id", subject);
                temp.append("teacher_id", teacher.value);
                temp.append("period", selectedCell.period.id);
                temp.append("day", selectedCell.day);
                if (localStorage.getItem("Role") === "1" && acaid !== "") {
                    temp.append("academy_id", acaid.value);
                }

                savetimetabledet(temp).then((res) => {
                    if (res.status === true) {
                        setShowModal(false);
                        setSubject("");
                        setTeacher("");
                        toast.success(res.message);
                        listtime();
                    }
                })
            } else {
                setErrorMsg("Please Select Teacher");
            }

        } else {
            setErrorMsg("Please Select Subject");
        }

    };

    function listtime() {
        const temp1 = new FormData();
        if (localStorage.getItem("Role") === "1" && acaid !== "") {
            temp1.append("academy_id", acaid.value);
        }
        temp1.append("class", sclass.value);
        temp1.append("section", studiv.value);
        temp1.append("year", ayear);

        listtimetabledet(temp1).then((res) => {
            if (res.status === true) {
                let timetableData = res.data;
                let userRole = Number(localStorage.getItem("Role"));
                let userId = localStorage.getItem("UID");

                if (userRole == 5) {
                    timetableData = timetableData.filter(
                        (item) => String(item.teacher_id) == userId
                    );
                }

                const allPeriods = periods;
                const mergedPeriods = allPeriods.map((period) => {
                    const daysData = {};
                    studays.forEach((day) => {
                        const entry = timetableData.find(
                            (item) => item.period === period.id && item.day === day
                        );
                        daysData[day] = entry || null;
                    });
                    return {
                        ...period,
                        days: daysData // attach timetable data if available
                    };
                });
                setPeriod([...mergedPeriods]);
            }
        })
    }
    return (
        <div>
            <div className="page-header">
                <h2 className="main-content-title tx-24 mg-b-5">Time Slot</h2>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <a>Time Table</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                        Time Slot
                    </li>
                </ol>
            </div>
            {loading && (
                <div className="loader-wrapper">
                    <div className="loader"></div>
                    <h3>Loading...Please do not go back or close the window.</h3>
                </div>
            )}
            {!loading && (
                <div className="content-body">
                    <div className="container-fluid">
                        <div className="row">

                            {localStorage.getItem("Role") !== "4" && (
                                <div className="col-xl-12">
                                    <div className="card">
                                        <div className="card-header">
                                            <h2 className="main-content-title tx-24 mg-b-5">
                                                Timetable
                                            </h2>
                                        </div>
                                        <div className="card-body">
                                            <div className="row">
                                                {localStorage.getItem("Role") === "1" && (
                                                    <div className="col-xl-4 col-sm-6">
                                                        <div className="mb-6">
                                                            <label className="form-label">Select Academy</label>
                                                            <Select
                                                                className="default-select"
                                                                placeholder="Select Academy"
                                                                value={acaid}
                                                                options={alist}
                                                                onChange={handleAcademy}
                                                                isSearchable={true}
                                                                isClearable
                                                                hidden
                                                            />
                                                        </div>
                                                    </div>
                                                )}

                                                <div className="col-xl-4 col-sm-6">
                                                    <div className="mb-6">
                                                        <label className="form-label">
                                                            Academic Year<span className="text-danger"> *</span>
                                                        </label>
                                                        <select
                                                            className="default-select  form-control wide"
                                                            value={ayear}
                                                            onChange={(e) => setAYear(e.target.value)}
                                                        >
                                                            <option value="" disabled>
                                                                Select Academic Year
                                                            </option>
                                                            {ylist.map((item, i) => {
                                                                return (
                                                                    <option value={item.id} key={i}>
                                                                        {item.aca_year}
                                                                    </option>
                                                                );
                                                            })}
                                                        </select>
                                                    </div>
                                                </div>

                                                <div className="col-xl-4 col-sm-6">
                                                    <div className="mb-6">
                                                        <label className="form-label">
                                                            Select Class<span className="text-danger"> *</span>
                                                        </label>
                                                        <Select
                                                            className="default-select"
                                                            placeholder="Select Class"
                                                            value={sclass}
                                                            options={clist}
                                                            onChange={handleClass}
                                                            isSearchable={true}
                                                            isClearable
                                                            hidden
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-xl-4 col-sm-6">
                                                    <div className="mb-6">
                                                        <label className="form-label">
                                                            Select Section
                                                            <span className="text-danger"> *</span>
                                                        </label>
                                                        <Select
                                                            className="default-select"
                                                            placeholder="Select Section"
                                                            value={studiv}
                                                            options={divlist}
                                                            onChange={handleDiv}
                                                            isSearchable={true}
                                                            isClearable
                                                            hidden
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="res-right me-4 mt-4">
                                                <button
                                                    className="btn btn-secondary"
                                                    onClick={searchtime}
                                                >
                                                    Search
                                                </button>
                                            </div>
                                        </div>


                                    </div>
                                </div>
                            )

                            }
                            <div className="col-xl-12">
                                {/* {periods.length === 0 && tshow && (
                  <div className="text-center text-danger">
                    <h4>No Timetable Found</h4>
                  </div>
                )} */}
                                {tshow && (
                                    <div className="card">
                                        <div className="card-header">
                                            {localStorage.getItem("Role") !== "4" && (
                                                <div className="row">
                                                    <div className="col-xl-6 col-sm-6">
                                                        <h5 className="main-content-label tx-20 mt-2">
                                                            {" "}
                                                            {sclass.label} Std - {studiv.label}
                                                        </h5>{" "}
                                                    </div>

                                                </div>
                                            )}
                                            {localStorage.getItem("Role") === "4" && (
                                                <div className="row">
                                                    <div className="col-xl-6 col-sm-6">
                                                        <h5 className="main-content-label tx-20 mt-2">
                                                            {" "}
                                                            {cname}
                                                        </h5>{" "}
                                                    </div>
                                                    {/* <div className="col-xl-6 col-sm-6">
                                                        <a
                                                            className="btn btn-secondary"
                                                            style={{ float: "right" }}
                                                            onClick={downloadCSV}
                                                        >
                                                            Download
                                                        </a>
                                                    </div> */}
                                                </div>
                                            )}

                                        </div>


                                        <div className="timetable">
                                            <table>
                                                <thead>
                                                    <tr>
                                                        <th>Lecture/Day</th>
                                                        {studays.map((day) => (
                                                            <th key={day} style={{ color: "#000" }}>{day}</th>
                                                        ))}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {periods.map((period, i) => (
                                                        <tr key={i}>
                                                            <td className={`fw-bold`}>
                                                                {period.name}
                                                                <br />
                                                                <small>{period.from_time} - {period.to_time}</small>
                                                            </td>
                                                            {studays.map((day) => {
                                                                const cell = period.days && period.days[day];
                                                                return (
                                                                    <td
                                                                        key={`${day}-${i}`}
                                                                        style={{ backgroundColor: period.is_break == "Yes" ? "#ffeeba" : "" }}
                                                                        className={`align-middle ${period.is_break == "Yes" ? "table-danger" : "table-hover"} cursor-pointer`}
                                                                        onClick={() => {
                                                                            if (period.is_break == "No") handleCellClick(day, period);
                                                                        }}
                                                                    >
                                                                        {period.is_break === "No" && cell ? (
                                                                            <>
                                                                                {cell.subject_name}<br />
                                                                                {localStorage.getItem("Role") != "5" && (
                                                                                    <span style={{ color: 'blue' }}>{cell.teacher_name}</span>

                                                                                )}
                                                                                {localStorage.getItem("Role") == "5" && (
                                                                                    <span style={{ color: 'blue' }}>{cell.class_name} - {cell.section_name}</span>

                                                                                )}
                                                                            </>
                                                                        ) : (
                                                                            ""
                                                                        )}
                                                                    </td>
                                                                )
                                                            })}
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>



                                    </div>
                                )}
                            </div>

                            <Modal show={showModal} onHide={() => setShowModal(false)} size="md">
                                <Modal.Header>
                                    <Modal.Title>Assign Subject & Teacher</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <p>
                                        <strong>{selectedCell?.period?.name}</strong> on <strong>{selectedCell?.day}</strong>
                                    </p>
                                    <Form>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Subject</Form.Label>
                                            <Form.Select value={subject} onChange={(e) => setSubject(e.target.value)}>
                                                <option value="">Select Subject</option>
                                                {sublist.map((subject) => (
                                                    <option key={subject.id} value={subject.id}>{subject.subject_name}</option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Teacher</Form.Label>
                                            <Select
                                                className="default-select"
                                                placeholder="Select Teacher"
                                                value={teacher}
                                                options={tlist}
                                                onChange={handleStu}
                                                isSearchable={true}
                                                isClearable
                                                hidden
                                            />
                                        </Form.Group>
                                        {errorMsg && <span className="text-danger">{errorMsg}</span>}
                                    </Form>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                                        Cancel
                                    </Button>
                                    <Button variant="success" onClick={handleSave}>
                                        Submit
                                    </Button>
                                </Modal.Footer>
                            </Modal>


                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
